import Vue from 'vue'

export default {
  namespaced: true,
  state: () => ({
    list: []
  }),
  getters: {
    list: state => state.list,
    map: state => state.list.reduce((map, item) => {
      map[item.id] = Object.freeze(item)
      return map
    }, {}),
    categoryMap: state => state.list.reduce((map, device) => {
      let categoryId = device.deviceCategoryId
      let devices = map[categoryId]

      if (!Array.isArray(devices)) {
        devices = map[categoryId] = []
      }

      devices.push(device)

      return map
    }, {})
  },
  mutations: {
    list (state, list) {
      state.list = Object.freeze(list)
    }
  },
  actions: {
    request ({commit}) {
      return Vue.prototype.$api.Device.getList().then(devices => {
        commit('list', devices)
      }).catch(console.error)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/Device.js